import script from "./join.vue?vue&type=script&setup=true&lang=js"
export * from "./join.vue?vue&type=script&setup=true&lang=js"

import "./join.css?vue&type=style&index=0&id=35a7fd25&scoped=true&lang=css"

import exportComponent from "D:\\work\\gw-jw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a7fd25"]])

export default __exports__